"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLangPathByPath = exports.getLangPathByLang = void 0;
var __1 = require("..");
var routers_1 = require("../api/routers");
var helpers_1 = require("../api/helpers");
var debug = require("debug")("router:langHelpers");
/**
 * Get current lang path by Lang
 *
 * ex:
 * const route = {
 *     component: ...,
 *     path: { en: "/about", fr: "/a-propos", de: "uber", name: "about" },
 * }
 *
 * selectLangPathByLang(route, "fr") // will return  "/a-propos"
 *
 * @param route
 * @param lang
 */
function getLangPathByLang(route, lang) {
    var _a;
    if (lang === void 0) { lang = (_a = __1.LangService.currentLang) === null || _a === void 0 ? void 0 : _a.key; }
    var selectedPath;
    if (typeof route.path === "string") {
        selectedPath = route.path;
    }
    else if (typeof route.path === "object") {
        Object.keys(route.path).find(function (el) {
            var _a;
            if (el === lang)
                selectedPath = (_a = route.path) === null || _a === void 0 ? void 0 : _a[el];
        });
    }
    return selectedPath;
}
exports.getLangPathByLang = getLangPathByLang;
function getLangPathByPath(_a) {
    var _b, _c, _d;
    var path = _a.path, _e = _a.base, base = _e === void 0 ? null : _e, _f = _a.lang, lang = _f === void 0 ? ((_b = __1.LangService.currentLang) === null || _b === void 0 ? void 0 : _b.key) || undefined : _f, _g = _a.routes, routes = _g === void 0 ? routers_1.ROUTERS === null || routers_1.ROUTERS === void 0 ? void 0 : routers_1.ROUTERS.routes : _g, _h = _a.basePath, basePath = _h === void 0 ? null : _h, _j = _a.log, log = _j === void 0 ? false : _j;
    if (!routes) {
        log && debug("No routes is set, return", { routes: routes });
        return;
    }
    // store path
    var storePaths = [basePath];
    // inital path
    var initialPath = (path === null || path === void 0 ? void 0 : path[lang]) || path;
    // quick fix in case base is a simple "/"
    if (base === "/")
        base = "";
    // path without base
    var pathWithoutBase = helpers_1.removeBaseToUrl(initialPath, base);
    var _loop_1 = function (route) {
        log && debug("> route", route);
        // get current routePath
        var routePath = ((_c = route.path) === null || _c === void 0 ? void 0 : _c[lang]) || route.path;
        // check if path without base match with one of path lang
        var pathWithoutBaseMatchWithOnePathLang = typeof route.path === "object" &&
            Object.keys(route.path).some(function (l) { var _a; return ((_a = route.path) === null || _a === void 0 ? void 0 : _a[l]) === pathWithoutBase; });
        // prettier-ignore
        log && debug({ "route.path": route.path, base: base, storePaths: storePaths, routePath: routePath, pathWithoutBaseMatchWithOnePathLang: pathWithoutBaseMatchWithOnePathLang, pathWithoutBase: pathWithoutBase });
        if (routePath === pathWithoutBase || pathWithoutBaseMatchWithOnePathLang) {
            // pousser dans la tableau
            storePaths.push(routePath);
            log && debug("> FINAL return: ", helpers_1.joinPaths(storePaths));
            return { value: helpers_1.joinPaths(storePaths) };
        }
        // si ca match pas mais qu'il y a des children
        else if (((_d = route.children) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            log && debug("children > has children");
            // translate current base
            // prettier-ignore
            var translateBase = base ? getLangPathByPath({ path: base, lang: lang, routes: routes, log: false }) : base;
            log && debug("translateBase", translateBase);
            // prettier-ignore
            var match = getLangPathByPath({ path: path, base: base, lang: lang, basePath: translateBase, routes: route.children });
            log && debug("match >", match);
            if (match) {
                // keep path in local array
                log && debug("children match, return it");
                return { value: match };
            }
        }
    };
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var route = routes_1[_i];
        var state_1 = _loop_1(route);
        if (typeof state_1 === "object")
            return state_1.value;
    }
}
exports.getLangPathByPath = getLangPathByPath;
